import { render, staticRenderFns } from "./PlanoSaude.vue?vue&type=template&id=7ba6b70c&"
import script from "./PlanoSaude.vue?vue&type=script&lang=js&"
export * from "./PlanoSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports